// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__5FSo_","buttons":"Footer_buttons__2Hysv"};